import { render, staticRenderFns } from "./ReportsInGen.vue?vue&type=template&id=2405fb38&"
import script from "./ReportsInGen.vue?vue&type=script&lang=js&"
export * from "./ReportsInGen.vue?vue&type=script&lang=js&"
import style0 from "./ReportsInGen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports